var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPagearrowleftdouble(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.514 6.889a1.267 1.267 0 010-1.777L10.187.368a1.23 1.23 0 011.753 0 1.267 1.267 0 010 1.78L9.382 4.742h5.53c.328 0 .647.133.88.368.232.236.36.556.36.89 0 .333-.128.653-.36.888a1.239 1.239 0 01-.88.369h-5.53l2.558 2.595a1.26 1.26 0 01.363.89 1.274 1.274 0 01-.363.889 1.238 1.238 0 01-.877.368 1.224 1.224 0 01-.876-.368L5.514 6.889z",
    fill: "#2A848E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M.362 6.889a1.267 1.267 0 010-1.777L5.035.368a1.23 1.23 0 011.754 0 1.267 1.267 0 010 1.78L4.23 4.742 4 5c-.237.36-.23.388 0 0-.151.255-.5.667-.5 1 0 .333.152.5.367.889 0 0-.171-.199.133.111l.23.258L6.79 9.853a1.259 1.259 0 01.363.89 1.274 1.274 0 01-.363.889 1.239 1.239 0 01-.877.368 1.224 1.224 0 01-.877-.368L.362 6.889z",
    fill: "#2A848E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPagearrowleftdouble);
export default ForwardRef;